"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var fieldEntryImageCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {
    $scope.entry.canDeleteFile = true;
  };
  $scope.deleteFile = function(entry) {
    $scope.removeEntry(entry, 0);
  };
  init();
};
fieldEntryImageCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryImageCtrl;
